import { render, staticRenderFns } from "./serviceProvideManageList.vue?vue&type=template&id=c3503ea8&scoped=true"
import script from "./serviceProvideManageList.vue?vue&type=script&lang=js"
export * from "./serviceProvideManageList.vue?vue&type=script&lang=js"
import style0 from "./serviceProvideManageList.vue?vue&type=style&index=0&id=c3503ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3503ea8",
  null
  
)

export default component.exports